"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.celsiusToFahrenheit = celsiusToFahrenheit;
exports.deltaCelsiusToFahrenheit = deltaCelsiusToFahrenheit;
exports.fahrenheitToCelsius = fahrenheitToCelsius;
exports.getDisplayDelta = getDisplayDelta;
exports.getDisplayTemperature = getDisplayTemperature;
exports.getDisplayUnit = getDisplayUnit;
exports.getFixedTemp = getFixedTemp;
function celsiusToFahrenheit(value) {
  return value * 9 / 5 + 32;
}
function fahrenheitToCelsius(value) {
  return 5 * (value - 32) / 9;
}
function deltaCelsiusToFahrenheit(value) {
  return value * 9 / 5;
}
function getDisplayUnit() {
  var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "C";
  var displayUnit = unit.toUpperCase()[0];
  return displayUnit === "F" ? "F" : "C";
}
function getFixedTemp() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var temperatureUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "C";
  value = value == null ? 0 : value;
  temperatureUnit = getDisplayUnit(temperatureUnit);
  value = temperatureUnit === "F" ? celsiusToFahrenheit(value) : value;
  return Math.round(value * 10) / 10;
}
function getDisplayTemperature() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var temperatureUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "C";
  var displayValue = getFixedTemp(value, temperatureUnit);
  return "".concat(displayValue, " \xB0").concat(temperatureUnit);
}
function getDisplayDelta() {
  var delta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var temperatureUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "C";
  temperatureUnit = getDisplayUnit(temperatureUnit);
  if (temperatureUnit === "F") {
    delta = deltaCelsiusToFahrenheit(delta);
  }
  var displayDelta = getFixedTemp(delta);
  return "".concat(displayDelta, " \xB0").concat(temperatureUnit);
}